// extracted by mini-css-extract-plugin
module.exports = {"progressBarSize":"68px","strokeWidth":"4px"};